import { useEffect } from "react";

const BASE = process.env.REACT_APP_PUBLIC_SITE_URL || window.location.origin;

const setTag = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Client-side mirror of the server-rendered social metadata.
 * Crawlers read the server-rendered head (static index.html + /api/share/*);
 * this keeps in-app soft navigation and native share sheets in sync.
 */
export function useSeo({ title, description, image, path, type = "website", lang = "fr-CA", jsonLd, noindex = false }) {
  useEffect(() => {
    const url = path ? `${BASE}${path}` : BASE;
    const img = image
      ? (image.startsWith("http") ? image : `${BASE}${image}`)
      : `${BASE}/social/vytalidays-og.jpg`;

    if (title) document.title = title;
    document.documentElement.lang = lang;
    setTag("name", "description", description);
    setTag("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    setTag("property", "og:title", title);
    setTag("property", "og:description", description);
    setTag("property", "og:url", url);
    setTag("property", "og:image", img);
    setTag("property", "og:image:secure_url", img);
    setTag("property", "og:type", type);
    setTag("property", "og:site_name", "VytaliDays");
    setTag("name", "twitter:card", "summary_large_image");
    setTag("name", "twitter:title", title);
    setTag("name", "twitter:description", description);
    setTag("name", "twitter:image", img);
    setLink("canonical", url);

    let script = document.getElementById("vy-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "vy-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = typeof jsonLd === "string" ? jsonLd : JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, image, path, type, lang, jsonLd, noindex]);
}

/** Marks private/authenticated routes as noindex for crawlers. */
export function usePrivateSeo(title) {
  useSeo({ title: title ? `${title} · VytaliDays` : "VytaliDays", description: "", noindex: true });
}

export const SITE_BASE = BASE;
